"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ounces = exports.grains = exports.pounds = exports.grams = exports.acres = exports.roods = exports.perches = exports.rods = exports.links = exports.nauticalMiles = exports.cables = exports.fathoms = exports.leagues = exports.miles = exports.furlongs = exports.chains = exports.yards = exports.feet = exports.thous = exports.inches = exports.days = exports.hours = exports.minutes = void 0;
var numberMeasure_1 = require("../measure/numberMeasure");
var base_1 = require("./base");
// Time
exports.minutes = numberMeasure_1.Measure.of(60, base_1.seconds, "min");
exports.hours = numberMeasure_1.Measure.of(60, exports.minutes, "hr");
exports.days = numberMeasure_1.Measure.of(24, exports.hours, "d");
// Length
exports.inches = numberMeasure_1.Measure.of(0.0254, base_1.meters, "in");
exports.thous = numberMeasure_1.Measure.of(0.001, exports.inches, "th");
exports.feet = numberMeasure_1.Measure.of(12, exports.inches, "ft");
exports.yards = numberMeasure_1.Measure.of(3, exports.feet, "yd");
exports.chains = numberMeasure_1.Measure.of(22, exports.yards, "ch");
exports.furlongs = numberMeasure_1.Measure.of(10, exports.chains, "fur");
exports.miles = numberMeasure_1.Measure.of(8, exports.furlongs, "mi");
exports.leagues = numberMeasure_1.Measure.of(3, exports.miles, "lea");
exports.fathoms = numberMeasure_1.Measure.of(1.852, base_1.meters, "ftm");
exports.cables = numberMeasure_1.Measure.of(100, exports.fathoms, "cable");
exports.nauticalMiles = numberMeasure_1.Measure.of(10, exports.cables, "nmi");
exports.links = numberMeasure_1.Measure.of(7.92, exports.inches, "li");
exports.rods = numberMeasure_1.Measure.of(25, exports.links, "rd");
// Area
exports.perches = exports.rods.squared().withSymbol("perch");
exports.roods = exports.furlongs.times(exports.rods).withSymbol("rood");
exports.acres = exports.furlongs.times(exports.chains).withSymbol("acre");
// Mass
exports.grams = numberMeasure_1.Measure.of(0.001, base_1.kilograms, "g");
exports.pounds = numberMeasure_1.Measure.of(453.59237, exports.grams, "lb");
exports.grains = numberMeasure_1.Measure.of(1 / 7000, exports.pounds, "gr");
exports.ounces = numberMeasure_1.Measure.of(1 / 16, exports.pounds, "oz");
//# sourceMappingURL=common.js.map